// @core/api/endpoints/signature/get_signature_request.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SignatureRequestResponse,
} from '../../../types/signature';

const BASE_PATH = '/signature';

/**
 * Get signature request by ID
 * Retrieves signature request by the specified identifier.
 */
export async function GetSignatureRequest(
  request_id: string,
  options?: RequestOptions
): Promise<SignatureRequestResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/requests/:request_id`;
  requestPath = requestPath.replace(':request_id', encodeURIComponent(request_id));
  const requestOptions = options;
  return client.get<SignatureRequestResponse>(requestPath, { ...requestOptions });
}
